export const needHelpButtonWrapper = {
    'bottom': '3rem',
    'position': 'fixed',
    'right': '3rem',
    'zIndex': '$needHelpButton',
    // eslint-disable-next-line sort-keys
    '> button': {
        backgroundColor: '$needHelpButton',
        border: 'none',
        borderRadius: '$button',
        color: 'white',
        fontSize: '$needHelpButton',
        padding: '10px 25px',
    },
}
